import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// react admin
import { useGetIdentity } from "react-admin";
// mui
import { Grid, Button, Stack, useTheme } from "@mui/material";
// components
import { BasicInfo } from "./ProfileInfo/BasicInfo";
import { AccountInfo } from "./ProfileInfo/AccountInfo";
import { GameSettings } from "./ProfileInfo/GameSettings";
import { WinningScreenSettings } from "./ProfileInfo/WinningScreenSettings";
import { RecentActivity } from "./ProfileInfo/RecentActivity";
import { EditProfile } from "./Dialog/EditProfile";
import { ChangePassword } from "./Dialog/ChangePassword";

export const Profile = () => {
  const { data } = useGetIdentity();
  const navigate = useNavigate();
  const theme = useTheme();

  const EditUser = "/Assets/Icons/edit-user.svg";
  const CirclePassword = "/Assets/Icons/circle-password.svg";

  const [open, setOpen] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);

  // Handlers to open and close the dialog
  const handleClickOpen = () => {
    setOpen(true); // Open the dialog
  };
  const handleClickOpenPassword = () => {
    setOpenPassword(true); // Open the dialog
  };

  const handleClose = () => {
    setOpen(false); // Close the dialog
  };
  const handleClosePassword = () => {
    setOpenPassword(false); // Close the dialog
  };

  const isSuperUser = data?.userRoleName === "Super-User";

  // if (!isSuperUser) {
  //   navigate("/login");
  // }

  return (
    <React.Fragment>
      <Stack
        direction="row"
        spacing={2}
        sx={{ mt: 3, justifyContent: "flex-end" }}
      >
        <Button
          variant="outlined"
          color="secondary"
          startIcon={
            <img
              src={CirclePassword}
              alt="Edit"
              style={{ width: 18, height: 18 }}
            />
          }
          sx={{
            textTransform: "none",
            color: theme.palette.common.white,
            borderColor: theme.palette.grey[800],
            "&:hover": {
              borderColor: theme.palette.grey[800],
            },
          }}
          onClick={handleClickOpenPassword}
        >
          Change password
        </Button>
      </Stack>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={isSuperUser ? 4 : 6} md={isSuperUser ? 4 : 6}>
          <BasicInfo />
        </Grid>
        <Grid item xs={12} sm={isSuperUser ? 4 : 6} md={isSuperUser ? 4 : 6}>
          <AccountInfo />
        </Grid>
        {isSuperUser && (
          <Grid item xs={12} sm={4} md={4}>
            <GameSettings />
          </Grid>
        )}
        {isSuperUser && (
          <Grid item xs={12} sm={4} md={4}>
            <WinningScreenSettings />
          </Grid>
        )}
        {/* <Grid item xs={12} sm={12} md={12}>
          <RecentActivity />
        </Grid> */}
      </Grid>
      <EditProfile open={open} onClose={handleClose} />
      <ChangePassword open={openPassword} onClose={handleClosePassword} />
    </React.Fragment>
  );
};
